import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContainerNotify = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  background-color: ${({ theme }) => theme.neutral.white};
  width: 100%;
  height: 100vh;
  iframe {
    grid-area: iframe;
    width: 100%;
    height: 100%;
  }
`;

export const ContainerIframe = styled.div`
  margin-top: 0px;
  margin-left: 0px;
`;
